// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import SnippetsOutlinedSvg from "@ant-design/icons-svg/es/asn/SnippetsOutlined";
import AntdIcon from '../components/AntdIcon';

var SnippetsOutlined = function SnippetsOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: SnippetsOutlinedSvg
  }));
};

SnippetsOutlined.displayName = 'SnippetsOutlined';
export default React.forwardRef(SnippetsOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/SnippetsOutlined.js
// module id = 1845
// module chunks = 0